'use strict';

let URL = global.URL;
if ( ! URL )
	URL = require('url').URL;

import {galleryToken, iconToken, imageToken, linkToken, overlayToken, refToken, styleToken} from '../builder';
import Resolver from '../resolver';
import {UseMetadata} from '../results';

const VIDEO_URL = /^\/([^/]+)\/video\/(\d+)/,
	MOBILE_VIDEO_URL = /^\/v\/(\d+)/;
	//LOGO_URL = 'https://s16.tiktokcdn.com/musical/resource/wap/static/image/logo_144c91a.png';

export default class TikTok extends Resolver {
	transformURL(url, ctx) {
		if ( url.hostname === 'vm.tiktok.com' )
			return UseMetadata;

		if ( url.hostname === 'm.tiktok.com' ) {
			const match = MOBILE_VIDEO_URL.exec(url.pathname);
			if ( match ) {
				ctx.video_id = match[1];
				ctx.cache_key = `tiktok-vid-${ctx.video_id}`;
				return `https://www.tiktok.com/oembed?url=${url.toString()}`;
			}
		}

		const match = VIDEO_URL.exec(url.pathname);
		if ( match ) {
			ctx.username = match[1];
			ctx.video_id = match[2];
			ctx.cache_key = `tiktok-vid-${ctx.video_id}`;
			return `https://www.tiktok.com/oembed?url=${url.toString()}`;
		}

		// Got here somehow? Metadata~
		return UseMetadata;
	}

	processBody(data) {
		if ( data?.type !== 'video' )
			return null;

		const url_name = new URL(data.author_url).pathname.slice(1),
			has_name = ! /^user\d+$/.test(data.author_name);

		//console.log('data', data);

		return {
			v: 8,
			accent: '#000',

			fragments: {
				title: linkToken(
					data.author_url,
					styleToken({color: 'base'}, has_name ? data.author_name : url_name)
				),

				sub: has_name ? linkToken(
					data.author_url,
					styleToken({color: 'alt-2'}, url_name)
				) : null,

				media: this.builder()
					.addConditional(
						true, true,
						{
							type: 'player',
							iframe: `https://www.tiktok.com/embed/v2/${data.embed_product_id}`,
							aspect: data.thumbnail_width / data.thumbnail_height,
							content: overlayToken(
								imageToken(data.thumbnail_url, {aspect: data.thumbnail_width / data.thumbnail_height}),
								{
									center: styleToken({size: '2'}, iconToken('play'))
								}
							)
						}
					)
			},

			short: this.builder()
				.setLogo(iconToken('tiktok'))
				.setTitle(linkToken(
					data.author_url,
					[
						styleToken({color: 'base'}, has_name ? data.author_name : url_name),
						has_name ? ' ' : null,
						has_name ? styleToken({color: 'alt-2'}, url_name) : null
					]
				))
				.setSubtitle(data.title)
				.setExtra(data.provider_name),

			// Portrait videos are huge this shouldn't be "mid"
			/*mid: this.builder()
				//.setLogo(LOGO_URL, {sfw: true, aspect: 1})
				.setTitle(refToken('title'))
				.setSubtitle(refToken('sub'))
				.setCompactHeader()
				.addRef('media'),*/

			full: this.builder()
				.setLogo(iconToken('tiktok'))
				.setTitle(refToken('title'))
				.setSubtitle(refToken('sub'))
				.addBox({wrap: 'pre-wrap', 'mg-y': 'small', lines: 10}, data.title)
				.addRef('media')
				.setFooter(null, [data.provider_name], null, {compact: true})
		}
	}
}

TikTok.hosts = ['www.tiktok.com', 'm.tiktok.com'];
TikTok.examples = [
	{
		title: 'Full Link',
		url: 'https://www.tiktok.com/@littlewolfiebird/video/6924638564206628097'
	}
];
